import type { FC, ReactNode } from 'react'
import styled from 'styled-components'

import FraudWarning from '@/components/Fraud/Warning'
import type { Application } from '@/types/Activity'
import { FraudStatus } from '@/types/Activity'

interface Props {
  application: Application
  detailPills?: ReactNode
  actionButtons?: ReactNode
}

const OuterContainer = styled.div`
  display: grid;
  grid-gap: 10px;
`

const DetailsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`

const ActionsContainer = styled.div`
  display: grid;
  justify-items: end;
`

const Details: FC<Props> = ({ application, detailPills, actionButtons }) => {
  const fraudStatus = application.context?.fraud?.status ?? FraudStatus.notFraudulent
  const fraudDecision = application.context?.fraud?.decision ?? null

  return (
    <OuterContainer>
      <DetailsContainer>
        {detailPills}
        {actionButtons && <ActionsContainer>{actionButtons}</ActionsContainer>}
      </DetailsContainer>
      {fraudStatus !== undefined && fraudStatus !== FraudStatus.notFraudulent && (
        <FraudWarning status={fraudStatus} fraudDecision={fraudDecision} />
      )}
    </OuterContainer>
  )
}

export default Details
